import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (id) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const handleCareersClick = () => {
    navigate('/careers');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handlePolicyClick = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-brand">
              <div className="footer-logo">
                <div className="logo-icon">
                  <img src="/logo.png" alt="DT Consultancy Logo" />
                </div>
                <div className="logo-text">
                  <span className="logo-main">DT Consultancy</span>
                  <span className="logo-tagline">Digital Excellence</span>
                </div>
              </div>
              <p className="footer-description">
                Transforming businesses through innovative technology solutions, 
                strategic consulting, and cutting-edge digital services.
              </p>
              <div className="footer-social">
                <a href="https://www.linkedin.com/company/dt-consultancy-office/" target="_blank" rel="noopener noreferrer" className="social-icon-link">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM7 15H5v-6h2v6zM6 8c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm9 7h-2v-3c0-.8-.7-1.5-1.5-1.5S10 11.2 10 12v3H8V9h2v1c.5-.8 1.5-1 2-1 1.9 0 3 1.3 3 3v3z" fill="currentColor"/>
                  </svg>
                </a>
                <a href="https://x.com/ConsultancyDt" target="_blank" rel="noopener noreferrer" className="social-icon-link">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15 4L10 10L15 16H12.5L9 11.5L5.5 16H3L8 10L3 4H5.5L9 8.5L12.5 4H15Z" fill="currentColor"/>
                  </svg>
                </a>
                <a href="https://www.instagram.com/dtc_office/" target="_blank" rel="noopener noreferrer" className="social-icon-link">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="3" y="3" width="14" height="14" rx="3" stroke="currentColor" strokeWidth="1.5" fill="none"/>
                    <circle cx="10" cy="10" r="3" stroke="currentColor" strokeWidth="1.5" fill="none"/>
                    <circle cx="14.5" cy="5.5" r="0.8" fill="currentColor"/>
                  </svg>
                </a>
              </div>
            </div>

            <div className="footer-links">
              <h4>Quick Links</h4>
              <ul>
                <li><a onClick={() => scrollToSection('hero')}>Home</a></li>
                <li><a onClick={() => scrollToSection('services')}>Services</a></li>
                <li><a onClick={() => scrollToSection('solutions')}>Solutions</a></li>
                <li><a onClick={() => scrollToSection('about')}>About Us</a></li>
                <li><a onClick={() => scrollToSection('testimonials')}>Testimonials</a></li>
                <li><a onClick={handleCareersClick}>Careers</a></li>
              </ul>
            </div>

            <div className="footer-links">
              <h4>Our Services</h4>
              <ul>
                <li><a onClick={() => scrollToSection('services')}>Web Development</a></li>
                <li><a onClick={() => scrollToSection('services')}>Data Engineering</a></li>
                <li><a onClick={() => scrollToSection('services')}>AI Solutions</a></li>
                <li><a onClick={() => scrollToSection('services')}>Digital Marketing</a></li>
                <li><a onClick={() => scrollToSection('services')}>CAD Designing</a></li>
              </ul>
            </div>

            <div className="footer-contact">
              <h4>Contact Info</h4>
              <div className="contact-item">
                <span className="contact-icon">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 2C6.5 2 3 5 3 8.5c0 5 7 9.5 7 9.5s7-4.5 7-9.5C17 5 13.5 2 10 2z" fill="currentColor" opacity="0.6"/>
                    <circle cx="10" cy="8.5" r="2.5" fill="currentColor"/>
                  </svg>
                </span>
                <p>D-9, Ground Floor, Sec-3<br />Noida, UP 201301, India</p>
              </div>
              <div className="contact-item">
                <span className="contact-icon">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17 13v2c0 1-1 2-2 2-8 0-14-6-14-14 0-1 1-2 2-2h2c1 0 2 1 2 2v3c0 1-1 1-1 1s0 1 1 1c1 2 3 4 5 5 1 0 1 0 1-1 0 0 0-1 1-1h3c1 0 2 1 2 2z" fill="currentColor" opacity="0.6"/>
                  </svg>
                </span>
                <p><a href="tel:+918439533217">+91-8439533217</a></p>
              </div>
              <div className="contact-item">
                <span className="contact-icon">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="2" y="4" width="16" height="12" rx="2" fill="currentColor" opacity="0.6"/>
                    <path d="M2 6l8 5 8-5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                  </svg>
                </span>
                <p><a href="mailto:dt.consult.common@gmail.com">dt.consult.common@gmail.com</a></p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p>&copy; {currentYear} DT Consultancy. All rights reserved.</p>
            <div className="footer-legal">
              <a onClick={() => handlePolicyClick('/privacy-policy')}>Privacy Policy</a>
              <span className="separator">•</span>
              <a onClick={() => handlePolicyClick('/terms-of-service')}>Terms of Service</a>
              <span className="separator">•</span>
              <a onClick={() => handlePolicyClick('/cookie-policy')}>Cookie Policy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
